import { createFileRoute } from '@tanstack/react-router';
import { CatalogoPageAuthRecuperarSenha } from '@/features/catalogo/page/auth/recuperar-senha/CatalogoPageAuthRecuperarSenha';

export const Route = createFileRoute('/p/catalogo/$slug/auth/recuperar-senha')({
    component: CatalogoPageAuthRecuperarSenha,
});
